var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnergySavingsLeaf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13035_359770",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13035_359770)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 17.9766C14.1667 17.9766 15.575 17.3932 16.725 16.2266C17.875 15.0599 18.4667 13.6432 18.5 11.9766V5.97656H12.5C10.8333 6.0099 9.41667 6.60156 8.25 7.75156C7.08333 8.90156 6.5 10.3099 6.5 11.9766C6.5 13.6432 7.08333 15.0599 8.25 16.2266C9.41667 17.3932 10.8333 17.9766 12.5 17.9766ZM11.325 16.3016L15.925 12.2016C16.075 12.0682 16.1167 11.9099 16.05 11.7266C15.9833 11.5432 15.85 11.4349 15.65 11.4016L12.05 11.0516L14.2 8.07656C14.25 7.99323 14.2792 7.91406 14.2875 7.83906C14.2958 7.76406 14.2667 7.69323 14.2 7.62656C14.1333 7.54323 14.05 7.50573 13.95 7.51406C13.85 7.5224 13.7583 7.5599 13.675 7.62656L9.1 11.7266C8.95 11.8599 8.90833 12.0182 8.975 12.2016C9.04167 12.3849 9.175 12.4932 9.375 12.5266L12.975 12.8766L10.8 15.8516C10.75 15.9349 10.725 16.0141 10.725 16.0891C10.725 16.1641 10.7583 16.2349 10.825 16.3016C10.8917 16.3682 10.9708 16.4016 11.0625 16.4016C11.1542 16.4016 11.2417 16.3682 11.325 16.3016ZM12.5 19.9766C11.5667 19.9766 10.6875 19.8307 9.8625 19.5391C9.0375 19.2474 8.28333 18.8349 7.6 18.3016L6.225 19.6766C6.125 19.7766 6.0125 19.8516 5.8875 19.9016C5.7625 19.9516 5.63333 19.9766 5.5 19.9766C5.21667 19.9766 4.97917 19.8807 4.7875 19.6891C4.59583 19.4974 4.5 19.2599 4.5 18.9766C4.5 18.8432 4.525 18.7141 4.575 18.5891C4.625 18.4641 4.7 18.3516 4.8 18.2516L6.175 16.8766C5.64167 16.1932 5.22917 15.4391 4.9375 14.6141C4.64583 13.7891 4.5 12.9099 4.5 11.9766C4.5 9.74323 5.275 7.85156 6.825 6.30156C8.375 4.75156 10.2667 3.97656 12.5 3.97656H18.5C19.05 3.97656 19.5208 4.1724 19.9125 4.56406C20.3042 4.95573 20.5 5.42656 20.5 5.97656V11.9766C20.5 14.2099 19.725 16.1016 18.175 17.6516C16.625 19.2016 14.7333 19.9766 12.5 19.9766Z",
    fill: "#D3135A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergySavingsLeaf);
export default __webpack_public_path__ + "static/media/energy_savings_leaf.0548f89b3ea41bb68e45b5d8945fccbd.svg";
export { ForwardRef as ReactComponent };